import React from "react";
import ReactApexChart from "react-apexcharts";

const LineChart = ({ dataName, data, recommended }) => {
  const series =
    dataName === "Weight"
      ? [
          {
            name: dataName,
            data: data || [0, 0, 0, 0, 0, 0, 0],
          },
        ]
      : [
          {
            name: dataName,
            data: data || [0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "Goal",
            data: recommended,
          },
        ];

  // Calculate y-axis range for better visualization
  let yAxisConfig = {};
  if (dataName === "Weight" && data && data.length > 0) {
    const validWeights = data.filter(w => w > 0);
    if (validWeights.length > 0) {
      const minWeight = Math.min(...validWeights);
      const maxWeight = Math.max(...validWeights);
      const range = maxWeight - minWeight;

      // Add padding: if range is small, use fixed padding; otherwise use percentage
      const padding = range < 10 ? 10 : range * 0.3;

      yAxisConfig = {
        min: Math.max(0, minWeight - padding),
        max: maxWeight + padding,
      };
    }
  }

  const chartOptions = {
    chart: {
      type: "line",
      height: '100%',
      width: '100%',
      toolbar: {
        show: false, // 차트 상단의 툴바를 숨깁니다.
      },
      sparkline: {
        enabled: false
      }
    },
    // xaxis: {
    //   categories: [
    //     "Jan",
    //     "Feb",
    //     "Mar",
    //     "Apr",
    //     "May",
    //     "Jun",
    //     "Jul",
    //     "Aug",
    //     "Sep",
    //   ],
    // },
    stroke: {
      curve: "smooth", // 선의 형태를 부드러운 곡선으로 설정합니다.
      width: dataName === "체중" ? 4 : [4, 1], // 선 굵기
      dashArray: dataName === "체중" ? null : [, 2],
    },
    markers: {
      size: 0, // 기본 마커 사이즈를 0으로 설정하여 다른 모든 마커를 숨김
      discrete: [
        {
          seriesIndex: 0,
          dataPointIndex: 0, // 시작 인덱스
          fillColor: "#fff",
          strokeColor: "#FFC700",
          strokeWidth: 2,
          size: 4,
        },
        {
          seriesIndex: 0,
          dataPointIndex: 6, // 마지막 포인트의 인덱스
          fillColor: "#fff",
          strokeColor: "#FFC700",
          strokeWidth: 2,
          size: 4,
        },
      ],
    },

    legend: {
      show: false, // 범례 숨기기
    },
    grid: {
      show: false, // 그리드 숨기기
      padding: {
        top: 5,
        right: 5,
        bottom: 5,
        left: 5
      }
    },
    tooltip: {
      show: false, // 툴팁 숨기기
    },
    xaxis: {
      labels: {
        show: false, // X축 레이블 숨기기
      },
      axisBorder: {
        show: false, // X축 경계선 숨기기
      },
      axisTicks: {
        show: false, // X축 눈금 숨기기
      },
    },
    yaxis: {
      labels: {
        show: false, // Y축 레이블 숨기기
      },
      ...yAxisConfig,
    },
    colors: ["#FFC700", "#888787"],
  };

  return (
    <div style={{ width: '100%', height: '80px', overflow: 'hidden' }}>
      <ReactApexChart options={chartOptions} series={series} type="line" height="100%" />
    </div>
  );
};

export default LineChart;
